function openTab(event, tabName) {
  let tabContent = document.getElementsByClassName("steps-section__tab-content");
  let tabButtons = document.getElementsByClassName("steps-section__tab");

  if (tabContent && tabButtons) {
    for (let i = 0; i < tabContent.length; i++) {
      tabContent[i].classList.remove("active");
    }
    document.getElementById(tabName).classList.add("active");
  
    for (let i = 0; i < tabButtons.length; i++) {
      tabButtons[i].classList.remove("active");
    }
    event.target.classList.add("active");
  }
}